export default {
  types: 'Types de projet',
  type: 'Type de projet',
  verbose_type: 'un type de projet',
  messages: {
    type_not_found: 'Type de projet non trouvé',
  },
};
